// extracted by mini-css-extract-plugin
export default {"deck":"BannerDeck_deck__pma4X","deckContent":"BannerDeck_deckContent__Y-pGR","lastImage":"BannerDeck_lastImage__B4LUp"};